// src/components/SignupForm.js

import React, { useState } from 'react';
import axios from 'axios';
import './sign-up-form.styles.scss';

const SignupForm = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const mailchimpData = {
            email_address: email,
            status: 'subscribed', // or 'pending' for double opt-in
        };

        try {
            // Replace 'usX' in the URL with your Mailchimp data center ID
            const response = await axios.post(
                `https://us21.api.mailchimp.com/3.0/lists/de29769da4/members`,
                mailchimpData,
                {
                    headers: {
                        Authorization: `apikey f8fb0efa1c19e94a439d2d7ddb2403a1-us21`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 200) {
                setMessage('Thank you for signing up!');
            } else {
                setMessage('Oops! Something went wrong. Please try again.');
            }
        } catch (error) {
            setMessage('There was an error submitting the form.');
        }
    };

    return (
        <div className="signup-container">
            <h6>JOIN THE RANKS OF SUCCESSFUL BUSINESSES TODAY!</h6>
            <p>Sign Up Now for Priceless Resources to Elevate Your Brand</p>
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">SIGN ME UP!</button>
            </form>
            {message && <p className="message">{message}</p>}
        </div>
    );
};

export default SignupForm;
